export const getMsalConfig = (
  msalTenantId: string,
  msalClientId: string,
  pepsenseUrl: string
) => ({
  auth: {
    clientId: msalClientId,
    authority: `https://login.microsoftonline.com/${msalTenantId}`,
    redirectUri: window.location.origin,
    scope: 'https://rtd-metadata.azurewebsites.net/user_impersonation',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true,
  },
});

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};
